import LADRoutes from './components/LADRoutes';

function App() {
  return (
    <div style={{ width: '100vw', height: '100vh' }}>
      <>
        <LADRoutes />
      </>
    </div>
  );
}

export default App;
